import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export interface IProductAddCategoryResponse {
  status: boolean;
  message: string;
  data: { category_id: string };
}

export interface IProductAddCategoryProps {
  category_name: string;
}
export const useProductAddServiceCategoryAPI = () => {
  const configuration = useConfiguration();

  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: IProductAddCategoryProps) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(COUPON_SERVICE_APIS?.COUPON_VMS_CATEGORY?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IProductAddCategoryResponse>) => {
            if (res.data.status === true) {
              toast.success("Category has been added.");
              // return res.data.data.category_id;
              return { status: true, message: "batch" };
            } else {
              return { status: false, message: "batch_not_created" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return { status: false, message: "batch_not_created" };
          });
        return response;
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
